import styled, { css } from 'styled-components';
import BadgeLabel from 'components/BadgeLabel';
import { colors, device } from '../../styles/stylesheets';

const Icon = styled.img`
  width: 16px;
  height: 16px;
  margin-right: 8px;
  vertical-align: middle;
`;
export const Container = styled.div`
  align-items: center;
    
  background: ${colors.white};
  border: 1px solid ${colors.greyLighter};
  border-radius: 4px;
  padding: 16px;
  font-size: 12px;
  line-height: 16px;
  font-weight: 500;

  display: grid;
  @media ${device.fromTablet} {
    grid-template-areas: 
        "contact    quote      chat       actionQuote"
        "actionTask actionTask actionTask actionTask";
    grid-template-columns: minmax(180px, 1fr) 1fr 0fr 0fr;
  }
  @media ${device.untilTablet} {
    grid-template-areas: 
      "contact budge"
      "quote   quote"
      "chat    actionQuote"
      "actionTask actionTask";
    grid-template-columns: 1fr ${({ actionQuote }) => actionQuote}fr;
  }
`;

export const ContactInfo = styled.div`
  grid-area: contact;
  display: grid;
  grid-template-areas: "info-photo info-name"
                       "info-photo info-rating";
  grid-template-columns: 43px auto;
`;

export const ContactPhoto = styled.img`
  grid-area: info-photo;
  width: 35px;
  height: 35px;
  margin-right: 6px;
  clip-path: circle(50%);
`;

export const ContactName = styled.h4`
  grid-area: info-name;
`;
export const ContactRating = styled.div`
  grid-area: info-rating;
  font-size: 10px;
  line-height: 16px;
  display: flex;
`;

export const QuoteInfo = styled.div`
  grid-area: quote;
  display: grid;
  grid-template-areas: "quote-icon quote-title"
                       ".          quote-value";
  grid-template-columns: 24px auto;
  justify-content: flex-start;
  @media ${device.untilTablet} {
    margin: 20px 0;
    justify-content: flex-start;
  }
`;
export const QuoteIcon = styled(Icon)`
  grid-area: quote-icon;
`;
export const QuoteTitle = styled.p`
  grid-area: quote-title;
  font-size: 10px;
  text-anchor: middle;
  color: ${colors.greyMedium};
`;
export const QuoteValue = styled.p`
  grid-area: quote-value;
`;

export const ChatAction = styled.a`
  grid-area: chat;
  display: flex;
  justify-content: flex-end;
  color: ${colors.primary};
  position: relative;
  cursor: pointer;
  @media ${device.untilTablet} {
    justify-content: center;
  }
`;
export const IconChat = styled(Icon)`
`;
export const BudgeContainer = styled.div`
  grid-area: chat;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  @media ${device.untilTablet} {
    grid-area: budge;
  }
`;
export const BadgeCustom = styled(BadgeLabel)`
  margin: 0 !important;
`;

export const QuoteActionQuote = styled.div`
  grid-area: actionQuote;
  font-size: 10px;
  text-align: end;
  margin-left: 30px;
  @media ${device.untilTablet} {
    text-align: center;
    button {
      width: 100%;
    }
  }
`;
export const QuoteActionTask = styled.div`
  grid-area: actionTask;
  width: 100%;
  font-size: 10px;
  text-align: center;
  @media ${device.fromTablet} {
    margin-top: 20px;
  }
`;
export const ActionTaskIcon = styled(Icon)`
`;
